import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthProvider';

const links = [
  { href: '#greeting', label: '인사말' },
  { href: '#couple', label: '신랑 · 신부' },
  { href: '#ceremony', label: '예식 정보' },
  { href: '#gallery', label: '갤러리' },
  { href: '#map', label: '오시는 길' },
  { href: '#accounts', label: '마음 전하기' },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const { member } = useAuth();

  const cta =
    member?.role === 'admin'
      ? { to: '/admin', icon: 'ri-shield-user-line', label: '회원 관리' }
      : member?.status === 'approved'
        ? { to: '/my', icon: 'ri-gallery-line', label: '내 청첩장' }
        : { to: '/signup', icon: 'ri-edit-2-line', label: '청첩장 만들기' };

  return (
    <>
      <nav className="nav" aria-label="주요 메뉴">
        <a className="nav-brand" href="#top">
          <i className="ri-heart-3-line" aria-hidden="true" />
          <span>도윤 · 서연</span>
        </a>

        <div className="nav-links">
          {links.map((l) => (
            <a key={l.href} href={l.href}>
              {l.label}
            </a>
          ))}
        </div>

        <Link className="nav-cta" to={cta.to}>
          <i className={cta.icon} aria-hidden="true" />
          {cta.label}
        </Link>

        <button
          type="button"
          className="nav-burger"
          aria-label={open ? '메뉴 닫기' : '메뉴 열기'}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <i className={open ? 'ri-close-line' : 'ri-menu-line'} aria-hidden="true" />
        </button>
      </nav>

      {open ? (
        <div className="nav-mobile" role="dialog" aria-label="메뉴">
          <button
            type="button"
            className="nav-burger"
            aria-label="메뉴 닫기"
            style={{ position: 'absolute', top: 16, right: 20 }}
            onClick={() => setOpen(false)}
          >
            <i className="ri-close-line" aria-hidden="true" />
          </button>
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)}>
              {l.label}
            </a>
          ))}
          <a href="#rsvp" onClick={() => setOpen(false)}>
            참석 여부
          </a>
          <Link to={cta.to} onClick={() => setOpen(false)}>
            {cta.label}
          </Link>
        </div>
      ) : null}
    </>
  );
}